import React, { useState } from "react";
import { ListChecks, ClipboardList, FileText, MessageSquare, BarChart3 } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import EventChecklistTab from "@/components/admin/checklists/EventChecklistTab";
import TemplatesTab from "@/components/admin/checklists/TemplatesTab";
import EventNotesTab from "@/components/admin/checklists/EventNotesTab";
import OverviewDashboardTab from "@/components/admin/checklists/OverviewDashboardTab";

const EventManagementChecklists: React.FC = () => {
  const [activeTab, setActiveTab] = useState("checklist");
  const [preselectedEventId, setPreselectedEventId] = useState<string | null>(null);

  const handleSelectEventFromOverview = (eventId: string) => {
    setPreselectedEventId(eventId);
    setActiveTab("checklist");
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground flex items-center gap-2">
          <ListChecks className="h-6 w-6 text-secondary" />
          Checklists
        </h1>
        <p className="text-muted-foreground mt-1">Master checklist for every event — track tasks, templates, and team notes.</p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="checklist" className="gap-1"><ClipboardList className="h-4 w-4" /> Event Checklist</TabsTrigger>
          <TabsTrigger value="templates" className="gap-1"><FileText className="h-4 w-4" /> Templates</TabsTrigger>
          <TabsTrigger value="notes" className="gap-1"><MessageSquare className="h-4 w-4" /> Event Notes</TabsTrigger>
          <TabsTrigger value="overview" className="gap-1"><BarChart3 className="h-4 w-4" /> Overview</TabsTrigger>
        </TabsList>
        <TabsContent value="checklist"><EventChecklistTab /></TabsContent>
        <TabsContent value="templates"><TemplatesTab /></TabsContent>
        <TabsContent value="notes"><EventNotesTab /></TabsContent>
        <TabsContent value="overview"><OverviewDashboardTab onSelectEvent={handleSelectEventFromOverview} /></TabsContent>
      </Tabs>
    </div>
  );
};

export default EventManagementChecklists;
